import { render, staticRenderFns } from "./lecture-categories.vue?vue&type=template&id=3541a025&scoped=true"
import script from "./lecture-categories.vue?vue&type=script&lang=js"
export * from "./lecture-categories.vue?vue&type=script&lang=js"
import style0 from "./lecture-categories.vue?vue&type=style&index=0&id=3541a025&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3541a025",
  null
  
)

export default component.exports